import forms from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';
import Form from './Form.js';
import { BelowLayout, FloatingLayout } from './layouts.js';
import { configureValidation } from './config.js';

configureValidation(forms);

new Form('form.below', new BelowLayout());
new Form('form.text_inside_input_field', new FloatingLayout());

$.validator.addMethod('pattern', function (value, element, regexp) {
	return this.optional(element) || new RegExp(regexp).test(value);
}, '');

forms.init('form');
Zipcode.init();
